module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/store_images/3@2x_53b335b72c018d4aaf7a8dc0560bcaa8.png";